import { encodeBarcode } from '../model/barcode'

/**
 * Штрихкод картинкой (карточка 102, перенос `BarcodeSvg` старого клиента):
 * EAN-13, EAN-8, Code 128 — по самому значению. SVG с `crispEdges`: полосы
 * ложатся ровно в модули, термопринтер 203 dpi не прощает сглаживания.
 * Непечатное значение — `null`: ценник выйдет без штрихкода, но выйдет.
 */
export function BarcodeSvg({ value, className }: { value: string | null | undefined; className?: string }) {
  const encoded = encodeBarcode(value)
  if (encoded === null) return null

  // Соседние полосы сливаются в один прямоугольник: меньше узлов и ровнее край.
  const bars: { x: number; width: number }[] = []
  for (let i = 0; i < encoded.modules.length; i++) {
    if (encoded.modules[i] !== '1') continue
    const last = bars.at(-1)
    if (last !== undefined && last.x + last.width === i) last.width += 1
    else bars.push({ x: i, width: 1 })
  }

  return (
    <svg
      className={className}
      viewBox={`0 0 ${encoded.modules.length} 1`}
      preserveAspectRatio="none"
      shapeRendering="crispEdges"
      role="img"
      aria-label={`Штрихкод ${encoded.text}`}
    >
      {bars.map((bar) => (
        <rect key={bar.x} x={bar.x} y={0} width={bar.width} height={1} fill="#000" />
      ))}
    </svg>
  )
}
